// const debug = "resourcesSessionLoader"
const debug = false

export default function resourcesSessionLoader(dataToLoad:any):Promise<boolean> {


    // let deferredLoader = new Deferred(); // create new deferred object
    const loadPromise: Promise<boolean>  = new Promise((resolve, reject) => {

        debug && console.log(debug, "() dataToLoad=", dataToLoad);

        // Do nothin if there is nothing to load
        if (!dataToLoad || _.isEmpty(dataToLoad) ) {
            debug && console.log(debug, "sessionLoader.process -> NO data -> resolve()");
            resolve(true)
            return
        }


        if (debug) {
            console.groupCollapsed("@Session lazy loading (resources)...",_.size(dataToLoad))
            console.log(dataToLoad)
            console.groupEnd()
        }

        const findMissingData = (data:any)=>{
            const { taskTypes, projects } = data
            if (!taskTypes && !projects) return false

            let allCustomFields:any[] = []
            taskTypes && taskTypes.map((ttId:ID)=>{
                const taskType = gd.session.taskTypes.get(ttId)
                if (taskType) allCustomFields = _.union(allCustomFields, taskType.customFields)
            })

            projects && projects.map((pId:ID)=>{
                const project = gd.session.projects.get(pId);
                if (project) allCustomFields = _.union(allCustomFields, project.customFields)
            })

            return gd.session.findMissing({
                customFields: allCustomFields
            })
        }

        const sessionDataLoader = gd.api.Session.getMissingData(dataToLoad);

        sessionDataLoader.done((response:any)=>{

            //load custom fields data for just loaded taskTypes
            const cfDataToLoad = findMissingData(dataToLoad);
            if (cfDataToLoad) {
                let cfLoader = gd.api.Session.getMissingData(cfDataToLoad); // new ApiCall(this,'POST','session',cfDataToLoad);
                cfLoader.done((response:any)=>{ resolve(true) })
                cfLoader.fail((error:any)=>{ gd.apiError(error); reject() })
            } else {
                resolve(true)
            }
        })

        sessionDataLoader.fail((error:any)=>{
            gd.apiError(error)
            reject()
        })

    })

    return loadPromise
}
